
import { IDeleteOriginByNameProtocol } from '@/domain/application/protocols/origin/IDeleteOriginByNameProtocol'
import { IOriginsRepository } from '@/domain/application/repositories/IOriginsRepository'
import { DeleteOriginByNameUseCase } from '@/domain/application/useCases/origin/deleteOriginByName'
import { prismaService } from '@/infra/database/prisma'
import { PrismaOriginsRepository } from '@/infra/database/prisma/repositories/prismaOriginsRepository'
import { Request, Response } from 'express'
import { z, ZodError } from 'zod'

const deleteOriginQuerySchema = z.object({
  originName: z.string().min(1).max(200),
})

export class DeleteOriginController {
  private repository: IOriginsRepository = new PrismaOriginsRepository(prismaService)
  private useCase: IDeleteOriginByNameProtocol = new DeleteOriginByNameUseCase(
    this.repository,
  )

  async handle(request: Request, response: Response) {
    try {
      const { originName } = deleteOriginQuerySchema.parse(request.query)
      await this.useCase.execute({ originName })
      return response.status(204).send()
    } catch (error) {
      if(error instanceof Error) {
        if (error instanceof ZodError) {           
          return response.status(400).json({
            message: 
            error.issues[0].path.toString() === 'originName' ? 'Nome da praça no formato inválido' 
            : 'Erro na validação dos dados',
            error: error.flatten().fieldErrors
          }).send()
        }
        return response.status(400).json({
          message: error.message,
        }).send()
      }

      return response.status(500).json({
        message: 'Internal server error.'
      }).send()
    }
  }
}